/*
 * PDP Video-Reels: Kettenwiedergabe (miiva)
 *
 * Sobald ein Video durchgelaufen ist, startet automatisch das naechste.
 * Nach dem letzten geht es wieder beim ersten los. Desktop UND mobil.
 *
 * Voraussetzung: die Videos duerfen NICHT loopen - ein loopendes Video feuert nie
 * 'ended'. Im Markup (main-product.liquid) steht dafuer loop: false; hier wird es
 * zusaetzlich erzwungen, falls das Markup mal wieder umgestellt wird.
 *
 * Autoplay-Policy: Browser erlauben Autostart nur bei muted + playsinline -
 * beides wird unten sichergestellt. play() wird bewusst mit catch() abgesichert,
 * damit ein blockierter Autostart keine Fehler wirft.
 */
(function () {
  var REELS_SEL = '.wt-product-video-reels';

  function init() {
    var reels = document.querySelector(REELS_SEL);
    if (!reels) return;

    var videos = Array.prototype.slice.call(reels.querySelectorAll('video'));
    if (!videos.length) return;

    videos.forEach(function (v) {
      v.muted = true;
      v.loop = false;
      v.setAttribute('playsinline', '');
      v.removeAttribute('autoplay'); // Start steuert ausschliesslich diese Kette
    });

    var current = -1;

    function play(index) {
      current = ((index % videos.length) + videos.length) % videos.length;
      videos.forEach(function (v, i) {
        if (i !== current && !v.paused) v.pause();
      });
      var v = videos[current];
      try { v.currentTime = 0; } catch (e) {}
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    videos.forEach(function (v, i) {
      v.addEventListener('ended', function () {
        play(i + 1); // nach dem letzten wieder das erste
      });
      // Faellt ein Video aus (Netzwerk/Codec), nicht die ganze Kette anhalten
      v.addEventListener('error', function () {
        if (i === current) play(i + 1);
      });
    });

    // Erst starten, wenn die Videoleiste sichtbar ist: spart Daten und vermeidet,
    // dass der Browser den Autostart im Hintergrund blockiert.
    if ('IntersectionObserver' in window) {
      var started = false;
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting && !started) {
              started = true;
              play(0);
              io.disconnect();
            }
          });
        },
        { threshold: 0.25 }
      );
      io.observe(reels);
    } else {
      play(0);
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
